import { TreeNode } from '@shared/types/process';

export function makeTree<T extends { id: string; parentId?: string | null }>(
    itemsFull: T[],
    parentId: string | null = null,
): TreeNode<T>[] {
    return (
        itemsFull
            ?.filter((item) =>
                parentId ? item.parentId === parentId : !item.parentId,
            )
            ?.map<TreeNode<T>>((item) => ({
                ...item,
                children: makeTree(itemsFull, item.id),
            })) ?? []
    );
}
